<template>
  <div id="order_history_detail">
    <template v-if="isDispPrice">
      <div class="input_list">
        <ul>
          <li>
            <table class="order_price_table">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>単価</th>
                  <th>金額</th>
                </tr>
              </thead>
              <tbody>
                <tr class="b_separator">
                  <td>事前現場調査費</td>
                  <td></td>
                  <td>{{formatPrice(priceData.resrchPrice)}}</td>
                </tr>
                <tr>
                  <td>消費税</td>
                  <td>10%</td>
                  <td>{{formatPrice(priceData.resrchPriceTax)}}</td>
                </tr>
                <tr class="n_separator">
                  <td>合計金額（税込）</td>
                  <td></td>
                  <td>{{formatPrice(priceData.resrchTotalPrice)}}</td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'OrderPrice',
  components: {
  },
  props: {
    priceData: Object,
    isDispPrice: {
      type: Boolean,
      default: true
    },
    isConstruct: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/dc-cart.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.price_area {
  margin: 2rem 0;
  background: #ffffff;
  color: #000000;
  border: 0.1rem solid #ccc;
  border-radius: 0.5rem;
}
.n_separator {
  border-top: 0.1rem solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/payment/DcOrderResrch.vue